import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const MembershipBenefits = dynamic(() => import('./MembershipBenefits').then(mod => mod.MembershipBenefits));

export const MembershipBenefitsConfig = {
  emptyLabel: 'MembershipBenefits',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/membershipbenefits`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MembershipBenefitsEditable = (props: any) => {
  return (
    <EditableComponent config={MembershipBenefitsConfig} {...props}>
      <MembershipBenefits {...props} />
    </EditableComponent>
  );
};
